<script lang="ts">
    import ViewCharity from '../../components/employer/charities/ViewCharity.svelte';
    
    export let params: { id?: string } = {};
</script>

<ViewCharity charityId={params.id || ''} />   